export enum Type {
  TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
  TYPE_REGULAR_BIKE = 'TYPE_REGULAR_BIKE',
  TYPE_REGULAR_EBIKE = 'TYPE_REGULAR_EBIKE',
  TYPE_RACE_BIKE = 'TYPE_RACE_BIKE',
  TYPE_RACE_EBIKE = 'TYPE_RACE_EBIKE',
  TYPE_MOUNTAIN_BIKE = 'TYPE_MOUNTAIN_BIKE',
  TYPE_MOUNTAIN_EBIKE = 'TYPE_MOUNTAIN_EBIKE',
  TYPE_CARGO_BIKE = 'TYPE_CARGO_BIKE',
  TYPE_CARGO_EBIKE = 'TYPE_CARGO_EBIKE',
}

export enum AntiTheftMeasure {
  ANTI_THEFT_MEASURE_UNSPECIFIED = 'ANTI_THEFT_MEASURE_UNSPECIFIED',
  ANTI_THEFT_MEASURE_NONE = 'ANTI_THEFT_MEASURE_NONE',
  ANTI_THEFT_MEASURE_GPS = 'ANTI_THEFT_MEASURE_GPS',
  ANTI_THEFT_MEASURE_GPS_ANTITHEFT = 'ANTI_THEFT_MEASURE_GPS_ANTITHEFT',
  ANTI_THEFT_MEASURE_ANTITHEFT = 'ANTI_THEFT_MEASURE_ANTITHEFT',
}

export interface RiskProps {
  make?: string;
  model?: string;
  type?: Type;
  bikePurchaseDate?: string;
  originalValue?: number;
  serialNumber?: string;
  newBike?: boolean;
  antiTheftMeasure?: AntiTheftMeasure;
  lowTheftSensitiveness?: boolean;
}

export class Risk {
  make?: string;
  model?: string;
  type?: Type;
  bikePurchaseDate?: string;
  originalValue?: number;
  serialNumber?: string;
  newBike?: boolean;
  antiTheftMeasure?: AntiTheftMeasure;
  lowTheftSensitiveness?: boolean;

  constructor(props: RiskProps) {
    Object.assign(this, props);
  }
}
